'use client';

/**
 * FoundationChainDiagram — the connected-record chain: Requirement ->
 * Product -> Vendor -> Response -> Order (-> receipt, still open).
 *
 * Static SVG, no animation — unlike KlydePlatformGraphic's particle
 * flow, this diagram's job is legibility of the chain itself, not
 * motion. Styled with the app's real theme tokens (hsl(var(--...)))
 * so it's light/dark-aware automatically, ported from the marketing
 * artifact's bespoke navy/ochre chain diagram into the app's own
 * palette rather than carrying that palette over.
 *
 * Registered in react-media-registry.tsx as `FoundationChainDiagram`,
 * referenced by media.yaml's `foundation_chain_diagram` entry
 * (kind=react_component).
 *
 * @layer presentation
 * @arch_component_type widget
 * @arch_domain media
 */

const NODES: { x: number; label: string; sub: string; emphasis?: boolean; ghost?: boolean }[] = [
  { x: 70,  label: 'Requirement', sub: '"Dining chair"' },
  { x: 250, label: 'Product',     sub: 'catalogue' },
  { x: 430, label: 'Vendor',      sub: 'RFQ sent' },
  { x: 610, label: 'Response',    sub: 'real quote' },
  { x: 790, label: 'Order',       sub: 'PO raised', emphasis: true },
  { x: 970, label: 'receipt',     sub: '', ghost: true },
];

export function FoundationChainDiagram() {
  return (
    <svg viewBox="0 0 1040 150" width="100%" height="150" role="img" aria-label="Requirement to Product to Vendor to Response to Order, connected as one chain">
      <line
        x1={70} y1={75} x2={970} y2={75}
        stroke="hsl(var(--border))" strokeWidth={1.5}
        strokeDasharray="1 7" strokeLinecap="round"
      />
      {NODES.map((n) => (
        <g key={n.label} transform={`translate(${n.x},75)`} fontFamily="ui-monospace, monospace">
          <circle
            r={n.ghost ? 26 : n.emphasis ? 32 : 30}
            fill={n.emphasis ? 'hsl(var(--primary) / 0.14)' : n.ghost ? 'none' : 'hsl(var(--card))'}
            stroke={n.emphasis ? 'hsl(var(--primary))' : n.ghost ? 'hsl(var(--muted-foreground))' : 'hsl(var(--border))'}
            strokeWidth={n.emphasis ? 2 : 1.5}
            strokeDasharray={n.ghost ? '2 3' : undefined}
          />
          <text
            y={n.sub ? -3 : 4}
            textAnchor="middle"
            fontSize={9.5}
            fill={n.ghost ? 'hsl(var(--muted-foreground))' : 'hsl(var(--foreground))'}
            fontWeight={n.emphasis ? 600 : 500}
          >
            {n.label}
          </text>
          {n.sub && (
            <text y={9} textAnchor="middle" fontSize={8} fill="hsl(var(--muted-foreground))">
              {n.sub}
            </text>
          )}
        </g>
      ))}
    </svg>
  );
}
